export default __webpack_public_path__ + "static/media/m_use_action_back_xw.f13a3e90.png";